import { render, staticRenderFns } from "./igt-choice-field.vue?vue&type=template&id=799c53f7&scoped=true&"
import script from "./igt-choice-field.vue?vue&type=script&lang=js&"
export * from "./igt-choice-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799c53f7",
  null
  
)

export default component.exports